import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { markAppBootStart, startBootResumeGuard } from './components/loading/dismissAppBoot';
import { ensureAssetCacheVersion, hardReloadApp, isChunkLoadError } from './utils/assetCache';
import { ensureForcedStorageClear } from './utils/clearSiteStorage';
import { startIdlePageReload } from './utils/idleReload';
import './styles/fonts.css';
import './styles/global.css';
import './styles/notification-banner.css';
import './styles/mobile.css';
import './styles/loading.css';

void ensureForcedStorageClear().then((cleared) => {
  if (!cleared) ensureAssetCacheVersion();
});
startIdlePageReload();
markAppBootStart();
startBootResumeGuard();

window.addEventListener('unhandledrejection', (event) => {
  if (!isChunkLoadError(event?.reason)) return;
  event.preventDefault?.();
  hardReloadApp({ reason: 'chunk' });
});

window.addEventListener('error', (event) => {
  if (!isChunkLoadError(event?.error || event?.message)) return;
  hardReloadApp({ reason: 'chunk' });
});

createRoot(document.getElementById('root')).render(
  <StrictMode><App /></StrictMode>
);
